import React from "react";
import {Alert, Button, Col, Row} from "react-bootstrap";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "hooks";

export const NeedToUpdateUserData: React.FC = () => {

    const navigate = useNavigate()
    const needToUpdateData = useAppSelector((state) => state.user.needToUpdateData)

    if (!needToUpdateData || needToUpdateData.length === 0) {
        return <></>
    }

    return (
        <>
            <Row>
                <Col>
                    <Alert variant={"warning my-4"}>
                        <p>Es necesario que actualices los siguientes datos:</p>
                        <ul>
                            {
                                needToUpdateData.map((message, index) =>
                                    <li key={index}>{message}</li>
                                )
                            }
                        </ul>
                    </Alert>
                </Col>
            </Row>
            <Row>
                <Col className={"mb-4"} md={6}>
                    <Button
                        className={"btn purple-btn d-block w-100"}
                        onClick={() => navigate(ROUTE_PATHS.TUTOR_DATA_UPDATER)}
                    >
                        Editar datos del Padre/Madre/Tutor
                    </Button>
                </Col>
                <Col className={"mb-4"} md={6}>
                    <Button
                        className={"btn purple-btn d-block w-100"}
                        onClick={() => navigate(ROUTE_PATHS.KIDS_LIST)}
                    >
                        Editar datos de los hij@s
                    </Button>
                </Col>
            </Row>
        </>
    )

}
